import { render, staticRenderFns } from "./communityWgPerson.vue?vue&type=template&id=74447b82&scoped=true&"
import script from "./communityWgPerson.vue?vue&type=script&lang=js&"
export * from "./communityWgPerson.vue?vue&type=script&lang=js&"
import style0 from "./communityWgPerson.vue?vue&type=style&index=0&id=74447b82&prod&lang=less&scoped=true&"
import style1 from "./communityWgPerson.vue?vue&type=style&index=1&id=74447b82&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74447b82",
  null
  
)

export default component.exports